import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Header from "./Member/Navbar/Navbar";
import Home from "./Member/Home/Home";
import PageAnalyse from "./Member/PageAnalyse/PageAnalyse";
import SearchRdv from "./Member/SearchRdv/SearchRdv.js";
import PageConfirmation from "./Member/PageConfirmation/PageConfirmation";
import PageEnd from "./Member/PageEnd/PageEnd";
import FormCarander from "./Admin/Carander/FormCarander";
import RendezVous from "./Admin/RendezVous/RendezVous";
import Programe from "./Admin/Programe/Programe";
import SignIn from "./Login/SignIn/SignIn";
import SignUp from "./Login/SignUp/SignUp";
import { RoleTypes } from "./Login/Services/auth-constant";
import checkRole from "./Login/Services/check-role";
import checkAuth from "./Login/Services/check-auth";
import PageNotFound from "./PageNotFound/PageNotFound";
import MesRdv from "./Member/MesRdv/MesRdv";
import Login from "./Login/index";
import PrintRdv from "./Member/PageEnd/PrintRdv";
import ConfirmPwd from "./Login/ForgetPwd/ConfirmPwd";
import PageHomeAdmin from "./HomePage/PageHomeAdmin/PageHomeAdmin";
import PageHomeMember from "./HomePage/PageHomeMember/PageHomeMember";
import UserDetails from "./HomePage/PageHomeMember/UserDetails";
import Profile from "./HomePage/PageHomeAdmin/Profile/Profile";
import Calendar from "./HomePage/PageHomeAdmin/Calendar/Calendar";
import SuperAdmin from "./SuperAdmin/members";
import Patient from "./Admin/Patients/Patient";
import AddProfile from "./HomePage/PageHomeAdmin/Profile/Stepper/AddProfile";
import AddCabinet from "./HomePage/PageHomeAdmin/Profile/Stepper/AddCabinet";
import EditeProfile from "./HomePage/PageHomeAdmin/Profile/EditeProfile";
import Message from "./HomePage/PageHomeAdmin/Profile/Stepper/Message";
import Services from "./HomePage/PageHomeAdmin/Profile/Services";

function PrivateRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        checkAuth() ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

function App() {
  const [listMedecin, setListMedecin] = useState("");
  const [listService, setlistService] = useState([]);
  const [ville, setVille] = useState("");
  const [secteur, setSecteur] = useState("");
  const [checkAuthA, setCheckAuthA] = useState(true);

  return (
    <>
      <Router>
        <Switch>
          <PrivateRoute path="/home">
            <Route
              exact
              path="/home"
              render={() =>
                checkRole(RoleTypes.SUPER_ADMIN) ? (
                  <SuperAdmin />
                ) : checkRole(RoleTypes.ADMIN) ? (
                  <FormCarander />
                ) : checkRole(RoleTypes.USER) ? (
                  <AddProfile />
                ) : (
                  <Home />
                )
              }
            />
          </PrivateRoute>
          <PrivateRoute path="/pageanalyse">
            <PageAnalyse />
          </PrivateRoute>
          <PrivateRoute path="/searchrdv">
            <SearchRdv />
          </PrivateRoute>
          <PrivateRoute path="/pageconfirmation">
            <PageConfirmation />
          </PrivateRoute>
          <PrivateRoute path="/pageend">
            <PageEnd />
          </PrivateRoute>
          <PrivateRoute path="/mesrdv">
            <MesRdv />
          </PrivateRoute>
          <PrivateRoute path="/imprimer">
            <PrintRdv />
          </PrivateRoute>
          <Route
            path="/formcarander"
            render={() =>
              checkRole(RoleTypes.ADMIN) ? (
                <FormCarander />
              ) : (
                <Redirect to="/home" />
              )
            }
          />
          <Route
            path="/members"
            render={() =>
              checkRole(RoleTypes.SUPER_ADMIN) ? (
                <SuperAdmin />
              ) : (
                <Redirect to="/" />
              )
            }
          />
          <PrivateRoute path="/rendezvous">
            <RendezVous />
          </PrivateRoute>
          <PrivateRoute path="/programe">
            <Programe />
          </PrivateRoute>
          <PrivateRoute path="/patient">
            <Patient />
          </PrivateRoute>
          <PrivateRoute path="/message">
            <Message />
          </PrivateRoute>
          <PrivateRoute path="/addcabinet">
            <AddCabinet />
          </PrivateRoute>
          <PrivateRoute path="/editeprofile">
            <EditeProfile />
          </PrivateRoute>

          <PrivateRoute path="/calendar">
            <Calendar />
          </PrivateRoute>
          <Route path="/confirm/:email" component={ConfirmPwd} />
          <MedecinContext.Provider value={{ listMedecin, setListMedecin }}>
            <ListServiceContext.Provider
              value={{ listService, setlistService }}
            >
              <VilleContext.Provider value={{ ville, setVille }}>
                <SecteurContext.Provider value={{ secteur, setSecteur }}>
                  <CheckAuthAContext.Provider
                    value={{ checkAuthA, setCheckAuthA }}
                  >
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/profile" component={Profile} />
                    <PrivateRoute path="/services">
                      <Services />
                    </PrivateRoute>
                    <Route
                      exact
                      path="/pagehomeadmin"
                      component={PageHomeAdmin}
                    />
                    <Route exact path="/" component={PageHomeMember} />
                    <Route exact path="/userdetails" component={UserDetails} />
                  </CheckAuthAContext.Provider>
                </SecteurContext.Provider>
              </VilleContext.Provider>
            </ListServiceContext.Provider>
          </MedecinContext.Provider>
          {/* <Route path="/signup" component={SignUp} /> */}
          {/* <Route component={PageNotFound} /> */}
        </Switch>
      </Router>
      {/* <Login /> */}
    </>
  );
}

export default App;
export const MedecinContext = React.createContext();
export const VilleContext = React.createContext();
export const SecteurContext = React.createContext();
export const CheckAuthAContext = React.createContext();
export const ListServiceContext = React.createContext();
